// Reps see the writing rules that shape their drafts (team rules plus their own) and add or remove their own.
import { useState } from "react";
import { useMe } from "../App";
import { api, useApi } from "../lib/api";
import { Badge, Button, Card, Empty, ErrorNote, inputCls, Loading, PageHeader, useAction } from "../components/ui";

const BUILT_IN = [
  "Plain text only; no links, tracked links or HTML.",
  "Email 1: 60–100 words. Subject: at most 7 words, no colon.",
  "No throat-clearing openers (“reaching out”, “hope this finds you”, “quick question”, “following up”).",
  "No consultant jargon (“leverage”, “streamline”, “robust”, “synergy”, “empower”, “circle back”, “deep dive”).",
  "No CRM data: currency, 3+ digit numbers, dates, pipeline codes or license claims. These block approval.",
  "Email 3 mentions the LinkedIn connection attempt.",
  "Greeting, signature and the opt-out footer are added automatically.",
];

export default function MyRules() {
  const { me } = useMe();
  const { data, loading, reload } = useApi<any[]>("/rules/mine");
  const [text, setText] = useState("");
  const [banned, setBanned] = useState("");
  const act = useAction();
  const team = (data ?? []).filter((r) => r.scope === "team");
  const mine = (data ?? []).filter((r) => r.scope === "rep" && r.repSub === me.sub);
  return (
    <div className="space-y-5">
      <PageHeader title="My writing rules" sub="Claude follows these when drafting your campaigns, and the style check warns when an email breaks one." />
      {loading && !data ? (
        <Loading />
      ) : (
        <div className="grid gap-5 lg:grid-cols-2">
          <Card title="Your rules">
            {!mine.length ? (
              <Empty>No personal rules yet. Add one below, e.g. “Never open with a question” or “Sign off with first name only”.</Empty>
            ) : (
              <ul className="divide-y divide-line">
                {mine.map((r) => (
                  <li key={r.id} className="flex items-start justify-between gap-2 py-2.5 text-sm">
                    <div>
                      <div className="text-ink">{r.text}</div>
                      {r.banned?.length > 0 && <div className="text-xs text-muted">Warns on: {r.banned.map((b: string) => `“${b}”`).join(", ")}</div>}
                    </div>
                    <Button tone="ghost" onClick={() => act.run(async () => { await api(`/rules/mine/${r.id}`, { method: "DELETE" }); reload(); })}>
                      Remove
                    </Button>
                  </li>
                ))}
              </ul>
            )}
            <div className="mt-4 space-y-2 border-t border-line pt-4">
              <input className={inputCls} placeholder="New rule" value={text} onChange={(e) => setText(e.target.value)} />
              <input className={inputCls} placeholder="Phrases to warn on (comma-separated, optional)" value={banned} onChange={(e) => setBanned(e.target.value)} />
              <Button tone="primary" disabled={!text.trim() || act.busy} onClick={() => act.run(async () => { await api("/rules/mine", { body: { text, banned: banned.split(",").map((s) => s.trim()).filter(Boolean) } }); setText(""); setBanned(""); reload(); })}>
                Add rule
              </Button>
              <ErrorNote error={act.error} />
            </div>
          </Card>
          <div className="space-y-5">
            <Card title="Team rules">
              {!team.length ? <Empty>No team rules yet. Admins add them, and accept ones Claude proposes from everyone's edits.</Empty> : (
                <ul className="space-y-1.5 text-sm">
                  {team.map((r) => <li key={r.id} className="flex items-start gap-2 text-ink-2"><Badge tone="accent">team</Badge>{r.text}</li>)}
                </ul>
              )}
            </Card>
            <Card title="Always on">
              <ul className="list-disc space-y-1 pl-5 text-sm text-ink-2">
                {BUILT_IN.map((r) => <li key={r}>{r}</li>)}
              </ul>
            </Card>
          </div>
        </div>
      )}
    </div>
  );
}
